<section>
  <!----------------------------- Landing Page Content ------------------------------>
  <div class="about-us-section">
    <div class="about-head-div">
      <h1>PAMLab Tools</h1>
    </div>
    <div class="pamlab-landing-div">
      <h1 class="pamlab-landing-header">Identify. Enhance. Optimize.</h1>
      <p class="pamlab-landing-description">
        Student Success begins with having the right information in front of us
        so we can be better prepared to advise students on their educational
        journey. The PAMLab offers the <b>support</b> administrators, advisors
        and students need to <b>enhance</b> performance and
        <b>optimize</b> retention.
      </p>
    </div>

    <div class="landing-page-pic-div">
      <div class="picture">
        <img [(src)]="env['logo_paths']['mainLandingPagePic']" alt="" />
      </div>
    </div>

    <div class="cards-img-div">
      <div class="cards-container">
        <mat-card class="example-card" *ngIf="!isStudent">
          <mat-card-header>
            <mat-card-title-group>
              <mat-card-title>Administrators</mat-card-title>
            </mat-card-title-group>
          </mat-card-header>
          <mat-card-content>
            <ul>
              <li>View historical trends</li>
              <li>Scan noticeable risk groups</li>
              <li>Provide future interventions</li>
              <li>Track metrics and course performance</li>
              <li>Analyze student program flow</li>
            </ul>
          </mat-card-content>

          <mat-card-actions>
            <button
              mat-button
              [routerLink]="['/home']"
              fragment="admin-support-section"
            >
              Explore Tools
            </button>
          </mat-card-actions>
        </mat-card>

        <mat-card class="example-card" *ngIf="!isStudent">
          <mat-card-header>
            <mat-card-title-group>
              <mat-card-title>Advisors</mat-card-title>
            </mat-card-title-group>
          </mat-card-header>
          <mat-card-content>
            <ul>
              <li>Assess individual student profiles</li>
              <li>Identify at-risk factors</li>
              <li>Explore possible course combinations for students</li>
              <li>
                Recommends and estimate grades for courses to help aid students
              </li>
            </ul>
          </mat-card-content>

          <mat-card-actions>
            <button
              mat-button
              [routerLink]="['/home']"
              fragment="success-metrics-section"
            >
              Explore Tools
            </button>
          </mat-card-actions>
        </mat-card>

        <mat-card class="example-card">
          <mat-card-header>
            <mat-card-title-group>
              <mat-card-title>Students</mat-card-title>
            </mat-card-title-group>
          </mat-card-header>
          <mat-card-content>
            <ul>
              <li>View academic profile</li>
              <li>
                Explore workable course combinations and course bottleneck
              </li>
              <li>
                Enhance student's performance with course recommendations and
                grade estimation
              </li>
              <li>Time-to-graduation</li>
            </ul>
          </mat-card-content>

          <mat-card-actions>
            <button
              mat-button
              [routerLink]="['/home']"
              fragment="success-metrics-section"
            >
              Explore Tools
            </button>
          </mat-card-actions>
        </mat-card>
      </div>
      <div class="pie-chart-img-div">
        <img [(src)]="env['logo_paths']['pieChartLandingPagePic']" alt="" />
      </div>
    </div>
  </div>

  <div class="dashboard-update-section">
    <div class="dashboard-update-header">
      <h1><u>Dashboard Updates</u></h1>
    </div>

    <div class="about-description-div">
      <div class="version-desc">
        <img [(src)]="env['logo_paths']['gearIcon']" alt="" />
        <p><b>Version:</b> 2.0.0 / {{ date }} <br /></p>
      </div>
      <div class="update-desc">
        <img [(src)]="env['logo_paths']['arrowsRotateIcon']" alt="" />
        <p>
          <b>Recent Updates:</b>
        </p>
      </div>
    </div>
  </div>

  <div class="contact-us-section">
    <contact-us></contact-us>
  </div>
</section>
